import { EntityChild } from 'app/shared/models/entity-child.model';
import { TagDTO } from 'app/shared/models/tag.models';
import { ColorVariantStatusTypeEnum } from '../../enum/color-variant-status-type.enum.model';
import { GenderTypeEnum } from '../../enum/gender-type.enum.model';
import { SizeGroupTypeEnum } from '../../enum/size-group-type.enum.model';
import { MediaResDTO, OrderedMediaDTO } from '../../../../shared/models/media.models';
import { TierDTO, ProductTier } from '../settings/tier.model';
import { VariantFullDTO, VariantBaseDTO, VariantPaletteDTO, VariantForCollapseVM, PriceListVariantElementDTO } from './variant.models';
import { PriceComputation } from 'app/shop/shared/models/product-variant';
import { PaletteLimitDTO } from 'app/shared/models/palette-limit.model';

export class ProductBase {
  id: number;
  title: string;
  storeId: number;
  code: string;
  extCode?: string;
  externalId: string;
  gender: GenderTypeEnum;
  isContinuative?: boolean;
  isCustomizableWithPlayers: boolean;
  tags?: ProductTagDTO[];
  lastModificationTime: string;
  creationTime: string;
  creatorId: number;
  lastModifierId: number;
  descriptionEnglish: string;
  descriptionFrench: string;
  descriptionSpanish: string;
  descriptionGerman?: string;
  description: string;
  quantityBuyIncrement: number;
  quantityMinimumPerOrder?: number;
  styleGroupId: number;
  hideAllMedia: boolean;
}

export class ProductBaseDTO extends ProductBase {
  media?: MediaResDTO;
}

export class ProductDTO extends ProductBaseDTO {
  pricesSummary?: ProductPricesSummary;
  variants?: VariantFullDTO[];
  seasons?: ProductTagDTO[];
  tiers?: TierDTO[];

  constructor(init?: ProductDTO) {
    super();
    Object.assign(this, init);
  }
}
export class AssortmentProductDTO {
  order: number;
  product: ProductDTO;
}

export class ProductMultiSelectVM extends ProductDTO {
  checked: boolean;
  constructor(init?: ProductMultiSelectVM) {
    super();
    Object.assign(this, init);
  }
}

export class ProductForCollapseVM extends ProductBaseDTO {
  order: number;
  imgPath: string;
  price: string;
  variants: VariantForCollapseVM[];
  newOrd?: number;
  oldOrd?: number;
  includedQty?: number;
  checked?: boolean;
  openedPanel?: boolean;
  disabled?: boolean;

  // colors?: ColorVariantsVM[];

  visible?: boolean;
  constructor(init?: ProductForCollapseVM) {
    super();
    Object.assign(this, init);
  }
}
export class ColorVariantsVM {
  id: number;
  extPaletteId?: number;
  name: string;
  imagePath: string;
  allSelected?: ColorVariantStatusTypeEnum;
  variantsLength?: string;
  variantsInRe: string;
  allInRe?: ColorVariantStatusTypeEnum;
  variantsInPre: string;
  allInPre?: ColorVariantStatusTypeEnum;
  checked?: boolean;
  variants: VariantForCollapseVM[];
  disabled?: boolean;
  productPaletteStockLimitId?: number;
  limit?: number;
  minimumQuantityForPreOrder?: number;
  minimumQuantityForReOrder?: number;
  paletteId?: number;
  constructor(init?: ColorVariantsVM) {
    Object.assign(this, init);
  }
}

export class ProductVM extends ProductBase {
  tiers: ProductTier[];
  media: OrderedMediaVm[];
  constructor(init?: ProductVM) {
    super();
    Object.assign(this, init);
  }
}

export class ProductPricesSummary {
  minimumWholesalePrice: number;
  minimumRetailPrice: number;
  maxWholesalePrice: number;
  maxRetailPrice: number;
}

export class ProductVariantVM extends VariantBaseDTO {
  imagePath: string;
  wholesalePrice: number;
  declare visibleForPreOrder: boolean;
  declare visibleForReOrder: boolean;
  size: SizeDTO;
  palette: VariantPaletteDTO;
  priceComputation?: PriceComputation;
  checked?: boolean;
  disabled?: boolean;
  constructor(init?: ProductVariantVM) {
    super();
    Object.assign(this, init);
  }
}

export class SizeDTO {
  id: number;
  name: string;
  nameEnglish?: string;
  nameFrench?: string;
  nameGerman?: string;
  nameItalian?: string;
  nameSpanish?: string;
  group: SizeGroupTypeEnum;
  sizeOrder: number;
}

export class CategoryDTO extends EntityChild {
  declare id: number;
  declare name: string;
}

export class SeasonDTO extends EntityChild {
  declare id: number;
  declare name: string;
}

export class OrderedMediaResDTO {
  media: MediaResDTO;
  order: number;
  visible: boolean;
  validityDateFrom: string;
  validityDateTo: string;
  constructor(init?: OrderedMediaResDTO) {
    Object.assign(this, init);
  }
}

export class OrderedMediaVm extends OrderedMediaDTO {
  isCover: boolean;
  constructor(init?: OrderedMediaVm) {
    super();
    Object.assign(this, init);
  }
}
export class ProductTagDTO extends TagDTO {
  checked: boolean;
  toDelete?: boolean;

  constructor(init?: ProductTagDTO) {
    super();
    Object.assign(this, init);
  }
}


export class ProductItemVM extends ProductBaseDTO {
  wholesalePrice: string;
  retailPrice: string;
  imagePath?: string;
  stockQty?: number;
  reOrderStatusLabel?: string;
  preOrderStatusLabel?: string;
  allImportedInRe?: boolean;
  allImportedInPre?: boolean;
  isPack?: boolean;

  checked: boolean;

  constructor(init?: ProductItemVM) {
    super();
    Object.assign(this, init);
    this.isPack = this.tags?.some(x => x.name?.toLowerCase() === "pack");
  }
}

export class PriceListVariantPriceDto {
  variantId: number;
  retailPrice: number;
  overrideWholesaleDiscountPercentage: number;
  constructor(init?: PriceListVariantPriceDto) {
    Object.assign(this, init);
  }
}

//Modello per product price list
export class PriceListProductDTO extends ProductBaseDTO {
  currency: string;
  paletteLimits?: PaletteLimitDTO[];
  pricesSummary?: ProductPricesSummary;
  seasons?: SeasonDTO[];
  variantsTotalAvailableQuantity?: number;
  variants: PriceListVariantElementDTO[];

  constructor(init?: PriceListProductDTO) {
    super();
    Object.assign(this, init);
  }
}
